<template>
  <div>
    <div class="card-header">
      <ul class="nav nav-tabs card-header-tabs" name="locale">
        <li class="nav-item locale-tab" v-for="locale in locales" :key="locale">
          <button
              type="button"
              class="nav-link"
              :class="{active: openTab===locale}"
              :id="`message-${locale}-tab`"
              @click="setOpenTab(locale)"
              role="tab"
              :aria-controls="`message-${locale}`"
              :aria-selected="openTab===locale"
          >
            <span v-text="$t(`js.backend.message_local_content.languages.${locale}`)"/>
            <button
                type="button"
                v-if="openTab === locale"
                @click.stop.prevent="removeLocale(locale)"
                class="ms-2 me-n2 p-0 text-danger btn btn-link"
                style="line-height: 18px;"
            >
              <i class="fas fa-times-circle"></i>
              <span
                  class="sr-only"
                  v-text="$t('js.backend.message_local_content.remove_language')"
              />
            </button>
          </button>
        </li>
        <li class="nav-item" v-if="unusedLocales.length > 0" :key="'new'">
          <button type="button" class="nav-link" :class="{active: openTab==='new'}" :id="`message-new-tab`" @click.prevent="setOpenTab('new')" role="tab" :aria-controls="`message-new`" :aria-selected="openTab==='new'">
            <i class="fa fa-plus"></i>
          </button>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <div class="tab-content">
        <div v-for="locale in locales" class="tab-pane fade" :class="{show: openTab===locale, active: openTab===locale}" :key="`message-${locale}`" :id="`message-${locale}`" role="tabpanel" :aria-labelledby="`message-${locale}-tab`">
          <label :for="`message_subject_${locale}`">{{ $t('js.backend.message_local_content.subject') }}</label>
          <div class="mb-3">
            <label class="sr-only" :for="`message_subject_${locale}`">{{ locale }}</label>
            <input :lang="locale" v-model="subject[locale]" class="form-control" type="text" :name="`message[subject][${locale}]`" :id="`message_subject_${locale}`">
            <input type="hidden" :value="locale" name="message[locales][]">
          </div>
          <Trumbowyg v-model="content[locale]" :config="wysiwygConfig" :lang="locale" :name="`message[content][${locale}]`"></Trumbowyg>
        </div>
        <div class="tab-pane fade" :class="{show: openTab==='new', active: openTab==='new'}" :id="`message-new`" role="tabpanel" :aria-labelledby="`message-new-tab`">
          <label class="mb-3">
            {{$t('js.backend.message_local_content.add_language')}}
            <select class="form-control" @change="addLocaleChangeHandler">
              <option selected value="blank">{{$t('js.backend.message_local_content.select_one')}}</option>
              <option v-for="locale in unusedLocales" :value="locale">{{$t(`js.backend.message_local_content.languages.${locale}`)}}</option>
            </select>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Trumbowyg from '../../shared/trumbowyg/Trumbowyg.vue'
import wysiwygConfig from '../../../entrypoints/backend/wysiwyg'
import {computed, reactive, ref} from "vue";
import { i18n } from "~/entrypoints/shared/i18n"

const props = defineProps<{
  currentLocale?: string;
  subject: Record<string, string>;
  content: Record<string, string>;
}>()

const currentLocale = ref<string>(props.currentLocale || i18n.global.locale as string);
const subject = reactive(props.subject || {
  [i18n.global.locale]: "",
})
const content = reactive(props.content || {
  [i18n.global.locale]: "",
})
const locales = computed<string[]>(()=>{
  return Object.keys({...subject, ...content})
});
const openTab = ref(locales.value.includes(currentLocale.value) ? currentLocale.value : locales.value[0] || 'new')
const unusedLocales = computed(()=>{
  return i18n.global.availableLocales.filter(locale => !locales.value.includes(locale))
});


function setOpenTab(locale){
  openTab.value = locale
}
function addLocaleChangeHandler(event){
  let selectedOption = event.target.selectedOptions[0];
  if(selectedOption && selectedOption.value !== 'blank'){
    addLocale(selectedOption.value)
  }
  event.target.selectedIndex = 0
}
function addLocale(locale){
  if(!locales.value.includes(locale)){
    subject[locale] = "";
    content[locale] = "";
  }
  setOpenTab(locale);
}
function removeLocale(locale){
  const index = locales.value.indexOf(locale);
  delete subject[locale];
  delete content[locale];
  setOpenTab(locales.value[Math.max(index-1, 0)] || 'new');
}
</script>